import * as React from "react";
const TrashIcon = (props) => (
  <svg
    width={17}
    height={18}
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.3125 4.80348H3.71131M3.71131 4.80348H14.9018M3.71131 4.80348V14.5951C3.71131 14.9661 3.85868 15.3219 4.12101 15.5843C4.38334 15.8466 4.73913 15.994 5.11012 15.994H12.1042C12.4752 15.994 12.8309 15.8466 13.0933 15.5843C13.3556 15.3219 13.503 14.9661 13.503 14.5951V4.80348H3.71131ZM5.80952 4.80348V3.40467C5.80952 3.03368 5.9569 2.67789 6.21923 2.41556C6.48155 2.15323 6.83735 2.00586 7.20833 2.00586H10.006C10.3769 2.00586 10.7327 2.15323 10.9951 2.41556C11.2574 2.67789 11.4048 3.03368 11.4048 3.40467V4.80348M7.20833 8.3005V12.4969M10.006 8.3005V12.4969"
      stroke="#D4001C"
      strokeWidth={1.39881}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default TrashIcon;
